module.exports = __webpack_public_path__ + "images/dashboard-delay-statistics-no-color@2x-c2b9c31e5d784f770704a4e4d54330b6.png";